import Grid from "@material-ui/core/Grid";
import React from "react";
import { useSelector } from "react-redux";
import {
  EnumStatisticChartType,
  EnumStatisticStatusGroup,
} from "../../../../server/routes/statistic/types";
import SettingTableProvider from "../../components/SettingTableProvider";
import Chart from "./Chart";
import { EnumChartAction } from "./Chart/types";
import SourceOrders from "./SourceOrders";
import defaultColumns from "./SourceOrders/Table/columns";
import Statistic from "./Statistic";
import StatusGroupProvider from "./StatusGroupProvider";
import { DashboardArticleFC } from "./types";
const DashboardArticle: DashboardArticleFC = () => {
    const { statisticChart } = useSelector(({ statisticChart }) => ({
        statisticChart: statisticChart[EnumStatisticStatusGroup.RECEIVED],
    }));
    return (
        <Grid
            container
            rowSpacing={2}
            alignItems={"stretch"}
            justifyContent={"center"}
        >
            <Grid item xs={12}>
                <Statistic />
            </Grid>
            <StatusGroupProvider
                statusGroup={EnumStatisticStatusGroup.RECEIVED}
                chartTitle={"Поступившие заявки"}
                additionalChart={
                    [
                        EnumStatisticChartType.ORDERS,
                        EnumStatisticChartType.REVENUE,
                    ].indexOf(statisticChart.type) === -1
                        ? undefined
                        : ["orders_received"]
                }
                gridTitle={"Отгруженные заказы"}
            >
                <Grid item xs={12}>
                    <Chart actions={[EnumChartAction.GROUP_BY_PERIOD]} />
                </Grid>
                <Grid item xs={12}>
                    <SettingTableProvider
                        defaultColumns={defaultColumns}
                        tableName="shippedOrders"
                    >
                        <SourceOrders />
                    </SettingTableProvider>
                </Grid>
            </StatusGroupProvider>
            <StatusGroupProvider
                statusGroup={EnumStatisticStatusGroup.DELIVERED}
                chartTitle={"Доставленные заказы"}
                gridTitle={"Доставленные заказы"}
            >
                <Grid item xs={12}>
                    <Chart
                        actions={[
                            EnumChartAction.GROUP_BY,
                            EnumChartAction.GROUP_BY_PERIOD,
                        ]}
                    />
                </Grid>
                <Grid item xs={12}>
                    <SettingTableProvider
                        defaultColumns={defaultColumns}
                        tableName="deliveredOrders"
                    >
                        <SourceOrders />
                    </SettingTableProvider>
                </Grid>
            </StatusGroupProvider>
        </Grid>
    );
};

export default DashboardArticle;
